import { homepageSeoContent } from '@/mocks/seoContent';
import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  const { ctaFinalTitle, ctaFinalSubtitle, safetyTitle, safetyContent } = homepageSeoContent;

  return (
    <>
      <section className="w-full bg-background-100 py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
            <div className="lg:w-1/2">
              <div className="rounded-3xl overflow-hidden aspect-[4/3] bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20cozy%20interior%20photography%20of%20a%20sunlit%20corner%20in%20a%20modern%20apartment%20with%20a%20comfortable%20armchair%2C%20soft%20knitted%20throw%20blanket%2C%20a%20small%20round%20wooden%20side%20table%20with%20a%20ceramic%20teacup%2C%20trailing%20ivy%20plant%20by%20the%20window%2C%20gentle%20morning%20sunlight%20streaming%20through%20sheer%20linen%20curtains%2C%20feeling%20of%20safety%20comfort%20and%20home%2C%20no%20text%2C%20hygge%20lifestyle%20aesthetic%20with%20soft%20golden%20tones&width=1200&height=900&seq=safety-section-v2&orientation=landscape"
                  alt="Safe shopping experience"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="lg:w-1/2">
              <span className="text-xs font-medium text-accent-600 uppercase tracking-wider whitespace-nowrap">
                Your Safety Matters
              </span>
              <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mt-3 mb-5">
                {safetyTitle}
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
                {safetyContent}
              </p>
              <div className="flex flex-wrap gap-3">
                {[
                  { icon: 'ri-shield-check-line', text: 'Verified Links' },
                  { icon: 'ri-eye-line', text: 'Transparent Info' },
                  { icon: 'ri-heart-line', text: 'Community Trusted' },
                  { icon: 'ri-lock-line', text: 'Secure Browsing' },
                ].map((item) => (
                  <span
                    key={item.text}
                    className="inline-flex items-center gap-1.5 px-4 py-2 bg-background-50 rounded-full text-xs font-medium text-foreground-600 whitespace-nowrap"
                  >
                    <i className={`${item.icon} text-accent-500`}></i>
                    {item.text}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-background-50 py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
          <h2 className="text-2xl md:text-5xl font-heading text-foreground-950 mb-4">
            {ctaFinalTitle}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8 max-w-lg mx-auto">
            {ctaFinalSubtitle}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Open Kakobuy Sheet
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 border border-foreground-200 text-foreground-700 rounded-full text-sm font-medium hover:border-foreground-400 transition-all whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}